import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "../services/api";
import "./DeductionsPage.css"; // Import shared CSS

const AddDeductionsPage = ({ selectedBusiness }) => { 
    const navigate = useNavigate();
    const location = useLocation();

    const businessId = selectedBusiness?.id;
    const employeeId = location.state?.employeeId;

    const [deductions, setDeductions] = useState({
        donation: "",
        garnishment: "",
    });

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await api.post(`/businesses/${businessId}/employees/${employeeId}/deductions`, {
                business_id: businessId,
                donation: deductions.donation || "",
                garnishment: deductions.garnishment || "",
            });
            alert("Deductions added successfully!");
            navigate(`/dashboard/business/employees`);
        } catch (error) {
            console.error("Error adding deductions:", error);
            alert("Failed to add deductions.");
        }
    };

    return (
        <div className="deductions-container">
            <h2 className="page-title-deduct">Add Deductions</h2>
            <form className="deductions-form" onSubmit={handleSubmit}>
                {Object.keys(deductions).map((key) => (
                    <div key={key}>
                        <label>
                            {key.replace("_", " ").toUpperCase()}:
                            <input
                                type="number"
                                value={deductions[key]}
                                onChange={(e) =>
                                    setDeductions({
                                        ...deductions,
                                        [key]: e.target.value === "" ? "" : parseFloat(e.target.value),
                                    })
                                }
                                placeholder={`Enter ${key.replace("_", " ")}`}
                            />
                        </label>
                    </div>
                ))}
                <div className="button-group">
                    <button className="save-button" type="submit">
                        Save Deductions
                    </button>
                    <button
                        className="cancel-button"
                        type="button"
                        onClick={() => navigate(`/dashboard/business/employees`)}
                    >
                        Cancel
                    </button>
                </div>
            </form>
        </div>
    );
};

export default AddDeductionsPage;



// import React, { useState } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import api from "../services/api";

// const AddDeductionsPage = () => {
//     const {id: businessId, employeeId } = useParams();
//     const navigate = useNavigate();

//     const [deductions, setDeductions] = useState({
//         contrib_401k: "",
//         healthcare: "",
//         dental: "",
//         vision: "",
//         donation: "",
//     });

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         try {
//             await api.post(`/businesses/${businessId}/employees/${employeeId}/deductions`, {
//                 business_id: businessId,
//                 contrib_401k: deductions.contrib_401k || 0,
//                 healthcare: deductions.healthcare || 0,
//                 dental: deductions.dental || 0,
//                 vision: deductions.vision || 0,
//                 donation: deductions.donation || 0,
//             });
//             alert("Deductions added successfully!");
//             navigate(`/dashboard/business/${businessId}`);
//         } catch (error) {
//             console.error("Error adding deductions:", error);
//             alert("Failed to add deductions.");
//         }
//     };

//     return (
//         <div>
//             <h2>Add Deductions</h2>
//             <form onSubmit={handleSubmit}>
//                 {Object.keys(deductions).map((key) => (
//                     <div key={key}>
//                         <label>
//                             {key.replace("_", " ").toUpperCase()}:
//                             <input
//                                 type="number"
//                                 value={deductions[key]}
//                                 onChange={(e) =>
//                                     setDeductions({
//                                         ...deductions,
//                                         [key]: e.target.value === "" ? "" : parseFloat(e.target.value),
//                                     })
//                                 }
//                                 placeholder={`Enter ${key.replace("_", " ")}`}
//                             />
//                         </label>
//                     </div>
//                 ))}
//                 <button type="submit">Save Deductions</button>
//                 <button type="button" onClick={() => navigate(`/dashboard/business/${businessId}/employees`)}>
//                     Cancel
//                 </button>
//             </form>
//         </div>
//     );
// };

// export default AddDeductionsPage;
